import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef } from 'react';
import { InternalEventType, WsMessage } from '../../../clients/chat/types';
import { GrispiNewsResponseType } from '../../../containers/GrispiNews/grispi-news.type';
import { getSelectedTabKeyFromUrl } from '../../../utils/routeHelper';
import { getGrispiNewsStore, getPluginStore } from '../../../utils/store/getStore';

const GrispiChatMessageUpdatesController = () => {
    const { asPath } = useRouter();

    const currentTabKey = getSelectedTabKeyFromUrl(asPath);
    const audioEl = useRef<HTMLAudioElement>(null);

    const incomingMessageHandler = useCallback(
        (event: CustomEventInit<{ message: WsMessage; chatSessionId: string }>) => {
            const ticketKey = getPluginStore().activeChatEntities.find(
                (e) => e.chatSessionId === event.detail.chatSessionId
            )?.ticketKey;

            if (ticketKey === undefined) {
                return;
            }
            if (ticketKey !== currentTabKey) {
                const messageData = {
                    c: 'CHAT_MESSAGE',
                    t: event.detail.message.receivedAt ?? Date.now(),
                    u: event.detail.message.senderId,
                    d: {
                        message: event.detail.message,
                        k: ticketKey
                    }
                } as GrispiNewsResponseType;
                getGrispiNewsStore().addNotification(messageData);
                // ring the bell here also when the browser tab is not focused
                if (audioEl.current) {
                    audioEl.current.pause();
                    audioEl.current.currentTime = 0; // to start over again
                    audioEl.current.play();
                }
            }
        },
        [audioEl, currentTabKey]
    );

    useEffect(() => {
        window.addEventListener(InternalEventType.INCOMING_MESSAGE, incomingMessageHandler);

        return () => {
            window.removeEventListener(InternalEventType.INCOMING_MESSAGE, incomingMessageHandler);
        };
    }, [incomingMessageHandler]);
    return <audio ref={audioEl} src="https://bigsoundbank.com/UPLOAD/ogg/2038.ogg" preload="auto" />;
};

export default GrispiChatMessageUpdatesController;
